import React from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { RECEIVE_TELEMATICS_BOX_POLL } from '../../../actions';
import { mapCanBusStatus, OnOffIcon, inputsStringToBinary } from './utilities';
import useLatestPoll from './useLatestPoll';
import _ from 'lodash';

const {
  dioStates,
  dioOptions: { manualPolls },
} = window.config;

export default function InputsStatus({ imei }) {
  const latestPoll = useLatestPoll(imei);
  const dispatch = useDispatch();

  function pollHeaders() {
    return (
      <TableRow>
        <TableCell>Ignition</TableCell>
        <TableCell>Time</TableCell>
        {[1, 2, 3, 4, 5, 6].map((input) => {
          return <TableCell key={input}>{input}</TableCell>;
        })}
        <TableCell>CAN Bus</TableCell>
        <TableCell>Driver ID</TableCell>
        {manualPolls && <TableCell>Cached History</TableCell>}
      </TableRow>
    );
  }

  const rawInputOn = (inputsBin, i) => {
    return inputsBin[7 - i] === '1';
  };

  const time = new Date().toISOString();
  function sendPoll(change) {
    dispatch({
      type: RECEIVE_TELEMATICS_BOX_POLL,
      payload: {
        imei,
        poll: {
          ...latestPoll,
          identifier: imei + '-' + time,
          time,
          ...change,
        },
      },
    });
  }

  // TODO tidy this up, duplicate in DriverIDSection
  function sendCached(data) {
    const mostRecent = data.payload.telematicsBoxes[imei].mostRecentPoll;
    const cached = data.payload.telematicsBoxes[imei].cachedPolls;
    const allPolls = _.orderBy(
      _.uniqBy([mostRecent, ...cached].filter(Boolean), "identifier"),
       "identifier");

    // if the imei was just created, it won't have a mostRecentPoll
    allPolls.forEach(sendPoll);
  }

  if (!latestPoll) {
    sendPoll({ deviceProperties: { inputs: 192 } });
  }

  function pollValues() {
    if (!latestPoll) {
      return <>No poll received</>;
    }

    const time = latestPoll.time
      ? moment(latestPoll.time).format(`DD/MM/YY HH:mm:ss`)
      : '';

    const dioKeys = Object.keys(dioStates);

    return (
      <TableRow>
        <TableCell>
          <OnOffIcon
            style={{ margin: '0 auto' }}
            on={latestPoll.ignitionOn}
            onClick={
              manualPolls &&
              (() =>
                sendPoll({
                  ignitionOn: !latestPoll.ignitionOn,
                  diagnosticCode: latestPoll.ignitionOn ? '4' : '3',
                }))
            }
          />
        </TableCell>
        <TableCell>{time}</TableCell>
        {[0, 1, 2, 3, 4, 5].map((input) => {
          const key = dioKeys[input];
          const binaryInputs = inputsStringToBinary(
            latestPoll.deviceProperties.inputs
          );

          return (
            <TableCell key={input}>
              <OnOffIcon
                style={{ margin: '0 auto' }}
                on={rawInputOn(
                  binaryInputs,
                  input // 0-based as opposed to label which is 1-based
                )}
                onClick={
                  manualPolls &&
                  (() =>
                    sendPoll({
                      [key]: !latestPoll[key],
                      diagnosticCode: '7',
                      deviceProperties: {
                        ...latestPoll.deviceProperties,
                        inputs:
                          192 |
                          (latestPoll.deviceProperties.inputs ^
                            Math.pow(2, input)),
                        // Math.pow(2, input)
                      },
                    }))
                }
              />
            </TableCell>
          );
        })}
        <TableCell style={{ width: '20%' }}>
          {latestPoll
            ? mapCanBusStatus(latestPoll.deviceProperties.canBusStatus)
            : ''}
        </TableCell>
        <TableCell style={{ width: '20%' }}>
          {latestPoll.driver ? latestPoll.driver.identificationReference : ''}
        </TableCell>
        {manualPolls && <TableCell>
          <OnOffIcon
            style={{ margin: '0 auto' }}
            on={latestPoll.cachedPolls?.length > 0}
            onClick={
              
              (() =>
              sendCached({
                payload: { telematicsBoxes: { [imei]: { 
                  cachedPolls: [
                    {
                      time: new Date(Date.now() - 3000).toISOString(),
                      identifier: imei + '-' + new Date(Date.now() - 3000).toISOString(),
                      diagnosticCode: '2',
                      ignitionOn: true,
                    },
                    {
                      time: new Date(Date.now() - 2000).toISOString(),
                      identifier: imei + '-' + new Date(Date.now() - 2000).toISOString(),
                      diagnosticCode: '3',
                      ignitionOn: true,
                    },
                    {
                      time: new Date(Date.now() - 1000).toISOString(),
                      identifier: imei + '-' + new Date(Date.now() - 1000).toISOString(),
                      diagnosticCode: '0',
                      ignitionOn: true,
                    },
                  ],
                  mostRecentPoll: {
                    ...latestPoll,
                  bufferCount: 1,
                  ignitionOn: true,
                  diagnosticCode: '2',
                  }
                }}}}
                ))
            }
          />
        </TableCell>}
      </TableRow>
    );
  }

  return (
    <Table>
      <TableHead>{pollHeaders()}</TableHead>
      <TableBody>{pollValues()}</TableBody>
    </Table>
  );
}
